var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7015 3.97237C10.7015 2.18136 9.39483 0.729492 7.78292 0.729492C6.171 0.729492 4.86432 2.18136 4.86432 3.97237C4.86432 5.76339 6.171 7.21526 7.78292 7.21526C9.39483 7.21526 10.7015 5.76339 10.7015 3.97237ZM7.10161 8.87386C5.29786 7.64697 2.37622 7.30984 0.90598 7.21695C0.411947 7.18587 0 7.60407 0 8.13205V15.6582C0 16.1423 0.352359 16.546 0.80535 16.572C2.1327 16.6493 4.81811 16.9328 6.67416 17.9715C6.95902 18.1309 7.29679 17.9137 7.29679 17.5705V9.26098C7.29649 9.10322 7.22626 8.95864 7.10161 8.87386ZM14.6599 7.21695C13.1899 7.3095 10.268 7.64697 8.46453 8.87386C8.33988 8.95864 8.26965 9.10897 8.26965 9.26672V17.5695C8.26965 17.9137 8.60833 18.1313 8.89411 17.9715C10.7499 16.9338 13.4337 16.6504 14.7608 16.573C15.2138 16.5467 15.5661 16.143 15.5661 15.6589V8.13205C15.5658 7.60407 15.1539 7.18587 14.6599 7.21695Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReads);
export default __webpack_public_path__ + "static/media/reads.6fca114d49399102f70344282e54977a.svg";
export { ForwardRef as ReactComponent };